import React, { useState, useEffect, useMemo } from "react"
import lodash from "lodash"
import { useRecoilState } from "recoil"

import { request } from "utils"
import { isLoadingState, templatesState } from "./state"

const useTemplates = () => {
  const [templates, setTemplates] = useRecoilState(templatesState)
  const [isLoading, setIsLoading] = useRecoilState(isLoadingState)

  const load = async () => {
    try {
      setIsLoading(true)
      const { data } = await request({ method: "get", url: "/api/presets" })
      setTemplates(data)
    } finally {
      setIsLoading(false)
    }
  }

  const remove = async id => {
    try {
      setIsLoading(true)
      const url = `/api/presets/${id}`
      const { data } = await request({
        method: "delete",
        url
      })
      load()
    } finally {
      setIsLoading(false)
    }
  }

  const reload = () => setTemplates(undefined)

  return { templates, isLoading, load, remove, reload }
}

export default useTemplates
